import { render, staticRenderFns } from "./addReback.vue?vue&type=template&id=57284e92&"
import script from "./addReback.vue?vue&type=script&lang=js&"
export * from "./addReback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports